exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-0df1c236] table > tbody > tr > td {\n\tcursor: pointer;\n}\n.header-content[data-v-0df1c236] {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n.label-txt[data-v-0df1c236] {\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tletter-spacing: 0.01em;\n\tcolor: rgba(6, 38, 62, 0.74);\n}\n", ""]);

// exports
